import { Divider, Stack, Typography } from "@mui/material";
import React from "react";

type Props = {
  your_data: number;
  external_data: number;
};

export const AnalyticsDataBlock = ({ your_data, external_data }: Props) => {
  const yourData = your_data ?? 0;
  const externalData = external_data ?? 0;

  const list = [
    { value: yourData, label: "CRM Data" },
    { value: externalData, label: "INFUSE Extension" },
    { value: 100 - externalData - yourData, label: "Gaps" },
  ];

  return (
    <Stack
      sx={{
        flexDirection: "row",
        gap: "24px",
        alignItems: "center",
        justifyContent: "space-around",
      }}
    >
      {list.map(({ label, value }, idx) => (
        <React.Fragment key={label}>
          <Stack
            sx={{
              flexDirection: "row",
              gap: "8px",
              alignItems: "center",
              padding: "6px 0",
            }}
          >
            <Typography variant="button" sx={{ color: "#232323" }}>
              {value}%
            </Typography>
            <Typography
              variant="button"
              sx={{ color: "#797979", fontWeight: 400 }}
            >
              {label}
            </Typography>
          </Stack>
          {list.length - 1 !== idx && (
            <Divider flexItem orientation={"vertical"} />
          )}
        </React.Fragment>
      ))}
    </Stack>
  );
};
